import React from 'react';
import { useRecoilValue } from 'recoil';
import { ProductPackShapesPicker } from '../ShapesPicker/ProductPackShapesPicker';
import { ProductPackVariantSelectorDetails } from '../../Details/productPackVariantSelectorDetails';
import { formatContentfulComponentProps } from '../../../../../../utils/globals';
import { productPackStepOptionState } from '../../../../../../utils/recoil/product';

export const ProductPackGlobalSelector = ({
  index,
  button,
  productMainDetails,
  category,
  products,
  hanldeOptionDelete,
}) => {
  const productPackStepOption = useRecoilValue(productPackStepOptionState);

  return (
    <div className='w-full overflow-scroll no-scrollbar'>
      {/* First pack step: shape selection */}
      {productPackStepOption[index] === 1 && (
        <ProductPackShapesPicker
          idx={index}
          button={button}
          products={products}
          category={category}
        />
      )}
      {/* Second pack step: variant detail selection */}
      {productPackStepOption[index] === 2 && (
        <div className='w-full overflow-scroll no-scrollbar'>
          <ProductPackVariantSelectorDetails
            idx={index}
            products={products}
            hanldeOptionDelete={() => hanldeOptionDelete(index)}
            {...formatContentfulComponentProps(productMainDetails)}
            category={category}
          />
        </div>
      )}
    </div>
  );
};
